<script>
import AdminTableSearch from '@components/admin-table-search.vue'
import AdminTableItem from '@components/admin-table-item.vue'

export default {
  components: {
    AdminTableSearch,
    AdminTableItem,
  },
  props: {
    tableType: { type: String, required: true },
    totalNum: { type: Number, required: true },
    tableFields: { type: Array, required: true },
    listData: { type: Array, required: true },
    dataLoaded: { type: Boolean, required: true },
    noNewBtn: { type: Boolean, required: false, default: false },
    noEditBtn: { type: Boolean, required: false, default: false },
    noFilterOption: { type: Boolean, required: false, default: false },
    noPage: { type: Boolean, required: false, default: false },
    noTotalLabel: { type: Boolean, required: false, default: false },
    hideSearchBar: { type: Boolean, required: false, default: false },
    curPage: { type: Number, required: false, default: 1 },
    perPage: { type: Number, required: false, default: 10 },
  },
  computed: {
    hasNoData() {
      return !this.listData.length && this.dataLoaded
    },
    loading() {
      return !this.listData.length && !this.dataLoaded
    },
    labelText() {
      return this.tableType === 'EVENT_ADMINS'
        ? 'event admins'
        : this.tableType.toLowerCase()
    },
  },
  methods: {
    goAddItem() {
      this.$emit('table-add-item')
    },
    setFilterParams(params) {
      this.$emit('table-set-filter-params', params)
    },
    setSortParams(params) {
      this.$emit('table-set-sort-params', params)
    },
    goEditItem(item) {
      this.$emit('table-go-edit-item', item)
    },
    deleteItem(id) {
      this.$emit('table-delete-item', id)
    },
    setPage(params) {
      this.$emit('table-set-page', params)
    },
  },
}
</script>

<template>
  <div class="">
    <AdminTableSearch
      :total-label="`Total number of   ${labelText}:`"
      :total-num="totalNum"
      :no-new-btn="noNewBtn"
      :no-filter-option="noFilterOption"
      :no-total-label="noTotalLabel"
      :hide-search-bar="hideSearchBar"
      :table-type="tableType"
      @set-filter-params="setFilterParams"
      @go-add-item="goAddItem"
    />
    <BaseTableHeader
      :header-data="tableFields"
      @set-sort-params="setSortParams"
    />
    <div class="table w-full">
      <div v-if="loading" class="w-full text-center py-24">
        Loading...
      </div>
      <div v-if="hasNoData" class="w-full text-center py-24">
        No data.
      </div>
      <AdminTableItem
        v-for="item in listData"
        :key="item.id"
        :item-data="item"
        :table-type="tableType"
        :table-fields="tableFields"
        :no-edit-btn="noEditBtn"
        @go-edit-item="goEditItem"
        @delete-item="deleteItem"
      >
        <template
          v-if="$scopedSlots.actions"
          v-slot:actions="{ item: actionItem }"
        >
          <slot name="actions" :item="actionItem" />
        </template>
      </AdminTableItem>
    </div>
    <BaseTableFooter
      v-if="!hasNoData && !noPage"
      :cur-page="curPage"
      :per-page="perPage"
      :total-num="totalNum"
      @set-page="setPage"
    />
  </div>
</template>
